import { RingLoader } from "react-spinners";
import { twMerge } from "tailwind-merge";

export default function LoaderOverlay({
  className,
  loadingComponent,
}: {
  className?: string;
  loadingComponent?: React.ReactNode;
}) {
  // Full screen position absolute 50% opacity black div with <Loader /> in the middle
  //   return (
  return (
    <div
      className={twMerge(
        "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 w-full h-full",
        className
      )}
    >
      {loadingComponent || (
        <RingLoader size={100} color="#33FA83" speedMultiplier={1.3} />
      )}
    </div>
  );
}
